import { Icon } from "@material-ui/core";
import * as React from "react";
import i18n from "../../../../Translations/i18n";
import PopoverPane from "../PopoverPane/PopoverPane";
import styles from "./PopoverPaneWrapper.scss";

interface IProps {
    id?: string;
    className?: string;
    children: React.ReactNode;
    currentStep: number;
    totalSteps?: number;
    title: string;
    nextPane: () => void;
    previousPane: () => void;
    deletePane: (currentStep: number) => void;
    addItemText: string;
    additionalHeaderControl?: JSX.Element;
}

export class PopoverPaneWrapper extends React.Component<IProps> {
    constructor(props: IProps) {
        super(props);
    }

    public render() {
        let currentStepTitle = null;
        if (this.props.totalSteps) {
            currentStepTitle = `(${this.props.currentStep}/${this.props.totalSteps})`;
        }

        return (
            <div className={`${styles.popoverPane} ${this.props.className}`}>
                <div className={styles.titleBar}>
                    <span className={styles.title}>
                        {this.props.title} {currentStepTitle}
                    </span>
                    <span className={styles.headerControls}>
                        {this.props.additionalHeaderControl}
                        <button id={`btn${this.props.id}Delete`} className={styles.deleteButton} onClick={() => this.props.deletePane(this.props.currentStep)}><Icon className={styles.icon}>delete</Icon> {i18n.t("common.delete")}</button>
                    </span>
                </div>
                <div className={styles.content}>
                    {this.props.children}
                </div>
                {this.props.totalSteps && this.props.currentStep ? (
                    <div className={styles.buttonBar}>
                        {1 < this.props.currentStep ? (
                            <a className={styles.previousButton} onClick={this.props.previousPane}>
                                <Icon>keyboard_arrow_left</Icon>
                                {i18n.t("common.step")} {this.props.currentStep - 1}
                            </a>
                        ) : null}
                        {this.props.totalSteps > this.props.currentStep ? (
                            <a className={styles.nextButton} onClick={this.props.nextPane}>
                                {i18n.t("common.step")} {this.props.currentStep + 1}
                                <Icon>keyboard_arrow_right</Icon>
                            </a>
                        ) : this.props.addItemText && this.props.addItemText.trim() ? (
                            <a className={styles.nextButton} onClick={this.props.nextPane}>
                                {this.props.addItemText}
                                <Icon>keyboard_arrow_right</Icon>
                            </a>
                        ) : null}
                    </div>
                ) : null}
            </div>
        );
    }
}

export default PopoverPane;


// WEBPACK FOOTER //
// ./src/Components/Common/Popover/PopoverPaneWrapper/PopoverPaneWrapper.tsx